
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.952 3.983c.013.174.013.347.013.523C17.965 9.844 13.837 16 6.29 16v-.003A11.75 11.75 0 010 14.186a8.322 8.322 0 006.073-1.674c-1.756-.033-3.296-1.16-3.834-2.806a4.152 4.152 0 001.853-.07C2.178 9.256.8 7.6.8 5.676v-.05c.57.312 1.21.486 1.863.505A4.007 4.007 0 011.393.737a11.708 11.708 0 008.456 4.22 4.003 4.003 0 011.187-3.86 4.153 4.153 0 015.806.176c.919-.178 1.8-.51 2.605-.98a4.067 4.067 0 01-1.803 2.233A8.26 8.26 0 0020 1.89a8.266 8.266 0 01-2.048 2.093z","fill":"#111224"}})])
          )
        }
      }
    